<wl-content-section [theme]="theme()">
  <wl-generic-products-section
    [title]="title()!"
    [content]="content()!"
    [rendering]="rendering()"
  />
</wl-content-section>
